const MAIN_URL = "http://localhost:5000/api";
export const FRONTEND_URL = "http://localhost:5000";

// API's for authentication

export const signUpEventAdmin = () => {
  return MAIN_URL + "/signUpEventAdmin";
};

export const signUpEventUser = () => {
  return MAIN_URL + "/signUpEventUser";
};

export const loginApi = () => {
  return MAIN_URL + "/login";
};

export const forgotPasswordApi = () => {
  return MAIN_URL + "/forgot-password";
};

export const resetPasswordApi = () => {
  return MAIN_URL + "/reset-password";
};

export const resetPasswordWithToken = () => {
  return MAIN_URL + "/resetpassword";
};

// API's for Users
export const getUsersByEventId = (eventId) => {
  return `${MAIN_URL}/users/by-event/${eventId}`;
};

export const updateUser = (userId) => {
  return `${MAIN_URL}/update-user/${userId}`;
};

// API's for lookup

export const getLookupName = () => {
  return MAIN_URL + "/lookup-name";
};

export const getLookupValue = () => {
  return MAIN_URL + "/lookup-values";
};

export const getLookupValueMaster = () => {
  return MAIN_URL + "/lookup-value-master";
};

export const addLookupValue = () => {
  return MAIN_URL + "/lookup-value";
};

export const updateLookupValue = () => {
  return MAIN_URL + "/lookup-value";
};

export const deleteLookupValue = () => {
  return MAIN_URL + "/lookup-value";
};



// API's for occation
export const addOccasion = () => {
  return MAIN_URL + "/add-occasion";
};

export const updateOccasion = (occasionId) => {
  return `${MAIN_URL}/occasions/update/${occasionId}`;
};

export const updateOccasionCount = (occasionId) => {
  return `${MAIN_URL}/occasions-count/update/${occasionId}`;
};


export const getOccasionsByEventId = (eventId) => {
  return `${MAIN_URL}/occasions/${eventId}`;
};

export const deleteOccasionData = (occasionId) => {
  return `${MAIN_URL}/occasions/delete/${occasionId}`;
};
// API's for occasion print
export const addOccasionPrintLabel = () => {
  return MAIN_URL + "/add-occasion-print-label";
};

export const updateOccasionPrintLabel = () => {
  return MAIN_URL + "/update-occasion-print-label";
};
// export const updateOccasionPrintLabel = (eventOccasionPrintId) => {
//   return `${MAIN_URL}/update-occasion-print-label/${eventOccasionPrintId}`;
// };

export const getOccasionDataPrintLabel = () => {
  return MAIN_URL + "/get-occasion-print-label";
};

// Dashboard 

export const statsForAllocatedOccasion = (eventId) => {
  return `${MAIN_URL}/allocated-occasion/stats/${eventId}`;
};

export const statsForinvitedOccasion = (eventId) => {
  return `${MAIN_URL}/invited-occasion-guest-stats/${eventId}`;
};

export const invitedGuestStats = (eventId, occasionId) => {
  return `${MAIN_URL}/invited-guest-stats/${eventId}/${occasionId}`;
};

export const confirmedGuestStats = (eventId) => {
  return `${MAIN_URL}/confirmed-guest-stats/${eventId}`;
};

export const confirmedOccasionGuestStats = (eventId, occasionId) => {
  return `${MAIN_URL}/confirmed-occasion-guest-stats/${eventId}/${occasionId}`;
};

// API's for Event Master

export const updateEventMaster = (eventId) => {
  return `${MAIN_URL}/update-event-master/${eventId}`;
};

export const getAllEventMasterDetails = () => {
  return MAIN_URL + "/get-all-events";
};

export const getSuperAdminDashboard = () => {
  return MAIN_URL + "/super-admin-dashboard";
};

export const getRoleAccessEvents = () => {
  return MAIN_URL + "/role-access/events";
};

export const updateEventRoleAccess = (eventId) => {
  return `${MAIN_URL}/role-access/events/${eventId}`;
};

export const getEventAccess = (eventId) => {
  return `${MAIN_URL}/event-access/${eventId}`;
};

export const deleteOccasionPrintData = () => {
  return MAIN_URL + "/delete-occasion-print-label";
};

// GuestMaster
export const addGuest = () => {
  return MAIN_URL + "/add-guest";
};

export const updateGuest = (guestId) => {
  return `${MAIN_URL}/update-guest/${guestId}`;
};

export const getAllMainGuests = (eventId) => {
  return `${MAIN_URL}/get-all-guests/${eventId}`;
};

export const getGuestsWithAttendees = (eventId) => {
  return `${MAIN_URL}/get-guest-with-attendes/${eventId}`;
};

export const deleteGuest = (guestId) => {
  return `${MAIN_URL}/delete-guest/${guestId}`;
};

// Guest Accomodation
export const addAccomodation = () => {
  return MAIN_URL + "/add-accomodation";
};

export const updateAccomodation = (accommodationId) => {
  return `${MAIN_URL}/update-accomodation/${accommodationId}`;
};

export const getGuestAccomodation = (eventId) => {
  return `${MAIN_URL}/get-accomodation/${eventId}`;
};

export const getAccommodationStatsByOccasion = (eventId, occasionId) => {
  return `${MAIN_URL}/accommodation-stats/${eventId}/${occasionId}`;
};

export const getStayReport = (eventId) => {
  return `${MAIN_URL}/stay-report/${eventId}`;
};

export const getGuestInviteReport = (eventId) => {
  return `${MAIN_URL}/reports/guest-invites/${eventId}`;
};

export const getTravelReport = (eventId) => {
  return `${MAIN_URL}/reports/travel/${eventId}`;
};

export const getSeatReport = (eventId) => {
  return `${MAIN_URL}/reports/seat-allocation/${eventId}`;
};

export const getPublicItinerary = () => {
  return `${MAIN_URL}/public-itinerary`;
};

export const deleteAccomodation = (id) => {
  return `${MAIN_URL}/delete-accomodation/${id}`;
};

// Hotel Master
export const addHotel = () => {
  return MAIN_URL + "/add-hotel";
};

export const updateHotel = (hotelId) => {
  return `${MAIN_URL}/update-hotel/${hotelId}`;
};

export const getHotelsByEventId = (eventId) => {
  return `${MAIN_URL}/get-hotels/${eventId}`;
};

export const deleteHotel = (id) => {
  return `${MAIN_URL}/delete-hotel/${id}`;
};

// Attendee Master

export const addAttendees = () => {
  return MAIN_URL + "/add-attendees";
};

export const updateAttendees = (attendeeId) => {
  return `${MAIN_URL}/update-attendees/${attendeeId}`;
};

export const getAllAttendees = (eventId) => {
  return `${MAIN_URL}/get-all-attendees/${eventId}`;
};

export const deleteAttendees = (guestId, attendeeId) => {
  return `${MAIN_URL}/delete-attendee/${guestId}/${attendeeId}`;
};
// Guest and Attendee Travel

export const addTravel = () => {
  return MAIN_URL + "/add-travel";
};

export const updateTravel = (guestId, attendeeId = "null") => {
  return `${MAIN_URL}/update-travel/${guestId}/${attendeeId || "null"}`;
};

export const getAllTravel = (eventId) => {
  return `${MAIN_URL}/get-travels/${eventId}`;
};

export const getTravelByGuest = (eventId, guestId, attendeeId = "null") => {
  return `${MAIN_URL}/get-travel/${eventId}/${guestId}/${attendeeId || "null"}`;
};

export const getGuestJourney = (eventId, guestId, attendeeId) => {
  const base = `${MAIN_URL}/guest-journey/${eventId}/${guestId}`;
  return attendeeId
    ? `${base}?attendeeId=${attendeeId}`
    : base;
};

export const deleteTravel = (id) => {
  return `${MAIN_URL}/delete-travels/${id}`;
};

// Guest Allocation 

export const guestAllocation = () => {
  return `${MAIN_URL}/guest-allocations`;
};

export const getAllocatedGuests = (eventId) => {
  return `${MAIN_URL}/get-allocated-guests/${eventId}`;
};

// RSVP Tracking

export const trackInvites = () => {
  return `${MAIN_URL}/track-invites`;
};

export const getTrackedInvites = (eventId) => {
  return `${MAIN_URL}/track-invites/${eventId}`;
};

export const publicRsvp = () => {
  return `${MAIN_URL}/public-rsvp`;
};

// Send Invites

export const sendInvites = () => {
  return `${MAIN_URL}/send-invites`;
};

export const getSentInvites = (eventId) => {
  return `${MAIN_URL}/savedInvites/${eventId}`;
};

export const updateSentInvite = (id, invitationId) => {
  return `${MAIN_URL}/update-invite/${id}/${invitationId}`;
};


// Seat Allocation 

export const allocateSeat = () => {
  return `${MAIN_URL}/allocate-seat`;
};

export const getSeatAllocation = (eventId) => {
  return `${MAIN_URL}/get-seat-allocations/${eventId}`;
};


// Travel 


// Send Email Invitation


export const sendEmailInvitation = () => {
  return `${MAIN_URL}/send-email-invitation`;
};

export const sendEmailInvite = () => {
  return `${MAIN_URL}/send-email-invite`;
};

export const previewEmailInvite = () => {
  return `${MAIN_URL}/preview-email-invite`;
};

export const sendWhatsAppInvite = () => {
  return `${MAIN_URL}/send-whatsapp-invite`;
};

export const previewWhatsAppInvite = () => {
  return `${MAIN_URL}/preview-whatsapp-invite`;
};

export const publishWhatsAppEventPass = () => {
  return `${MAIN_URL}/publish-whatsapp-event-pass`;
};


// Excel Sample template 

export const downloadGuestTemplate = (eventId) => {
  return `${MAIN_URL}/download-template`;
};

// Import Guest and Attendees
export const importGuestsAndAttendees = (eventId) => {
  return `${MAIN_URL}/import-excel`;
};

// Audit Logs
export const getAuditLogs = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      qs.set(key, value);
    }
  });
  const query = qs.toString();
  return `${MAIN_URL}/audit-logs${query ? `?${query}` : ""}`;
};

export const getAuditLogMeta = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      qs.set(key, value);
    }
  });
  const query = qs.toString();
  return `${MAIN_URL}/audit-logs/meta${query ? `?${query}` : ""}`;
};
